/* eslint-disable */
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ActionsApiConfiguration } from './actions-api-configuration';

import { ActionsService } from './services/actions.service';

/**
 * Module that provides all services and configuration.
 * Also exports Angular's `HttpClientModule`, as it is required for all services.
 */
@NgModule({
  declarations: [],
  imports: [],
  providers: [ActionsService, ActionsApiConfiguration, provideHttpClient(withInterceptorsFromDi())],
})
export class ActionsApiModule {}
